import React from 'react';
import PropTypes from 'prop-types';
import { SVG } from '../constants';

const propTypes = {
  airQuality: PropTypes.object
};

const AirQualityDisplay = ({ airQuality }) => {
  return (
    <div>
      <div style={{ display: 'flex', 'flexDirection': 'row', 'justifyContent': 'center' }}>
        <span className="pl-10 pr-10">{ airQuality ?
          <h4 className="intro-title">{airQuality.epa_health_concern} Air Quality</h4>
        : '' }
        </span>
      </div>
      <div className="row">
        <div className="col s12 m6 l6 xl6">
          <ul className="collection">
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.epa_aqi} alt={''} /></span>
              <span className="label2">EPA Air Quality Index</span><br />
              <span className="title2">{ airQuality ?
                <span className={airQuality.epa_aqi <= 50 ? 'green-text'
                  : airQuality.epa_aqi > 50 && airQuality.epa_aqi <= 100 ? 'yellow-text'
                  : airQuality.epa_aqi > 100 && airQuality.epa_aqi <= 150 ? 'orange-text'
                  : airQuality.epa_aqi > 150 && airQuality.epa_aqi <= 200 ? 'red-text'
                  : airQuality.epa_aqi > 200 && airQuality.epa_aqi <= 300 ? 'purple-text'
                  : airQuality.epa_aqi > 300 ? 'brown-text'
                  : '' }>
                {airQuality.epa_aqi} {airQuality.epa_health_concern}</span> : 'N/A' }</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.pm25} alt={''} /></span>
              <span className="label2">{'Particulate Matter < 2.5'} {"\u00B5"}m</span><br />
              <span className="title2">{ airQuality ? airQuality.pm25 : 'N/A' } {"\u00B5"}g/ft{"\u00B3"}</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.pm10} alt={''} /></span>
              <span className="label2">{'Particulate Matter < 10'} {"\u00B5"}m</span><br />
              <span className="title2">{ airQuality ? airQuality.pm10 : 'N/A' } {"\u00B5"}g/ft{"\u00B3"}</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.o3} alt={''} /></span>
              <span className="label2">Ozone (o3)</span><br />
              <span className="title2">{ airQuality ? airQuality.o3 : 'N/A' } ppb</span>
            </li>
          </ul>
        </div>
        <div className="col s12 m6 l6 xl6">
          <ul className="collection">
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.no2} alt={''} /></span>
              <span className="label2">Nitrogen Dioxide (no2)</span><br />
              <span className="title2">{ airQuality ? airQuality.no2 : 'N/A' } ppb</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.co} alt={''} /></span>
              <span className="label2">Carbon Monoxide (co)</span><br />
              <span className="title2">{ airQuality ? airQuality.co : 'N/A' } ppb</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><img height={"40px"} width={"40px"} src={SVG.so2} alt={''} /></span>
              <span className="label2">Sulfur Dioxide (so2)</span><br />
              <span className="title2">{ airQuality ? airQuality.so2 : 'N/A' } ppb</span>
            </li>
            <li className="collection-item avatar">
              <span className="circle2"><i className="wi wi-smog small"></i></span>
              <span className="label2">Primary Pollutant</span><br />
              <span className="title2">{ airQuality ? airQuality.epa_primary_pollutant : 'N/A' }</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
AirQualityDisplay.propTypes = propTypes;
export default AirQualityDisplay;

/* END */



// WEBPACK FOOTER //
// ./src/weather/components/airQuality_display.js